import { atom, useAtomValue, useSetAtom } from 'jotai';

import type { User } from '@/entities/user/user-types';

export const userAtom = atom<User | null>(null);
export const userLoadingAtom = atom(false);

export const useUserAtom = () => {
  const user = useAtomValue(userAtom);
  return user;
};

export const useSetUserAtom = () => {
  const setUser = useSetAtom(userAtom);
  return setUser;
};
